import { parse, stringify } from 'qs';

export const setQueryParams = (queryParams: Record<string, unknown>) => {
  const paramsString = stringify({
    ...parse(window.location.search, { ignoreQueryPrefix: true }),
    ...queryParams,
  });

  const { protocol, host, pathname } = window.location;

  const url = `${protocol}//${host}${pathname}?${paramsString}`;

  window.history.pushState('', document.title, url);
};
